import { apiClient } from './client';
import type { BaseplanCode, BaseplanCodeWrite, CodeBoard } from '@/types/oscar';

/**
 * Typed wrappers over the Region → Area → code board (BaseplanCodeFunctions.cs;
 * Data-Model §4.5.2). Reads: any Oscar role. Writes: oscar-admin.
 */

export function getCodeBoard(signal?: AbortSignal): Promise<CodeBoard> {
  return apiClient.get<CodeBoard>('/api/locations/codes', signal);
}

export function createBaseplanCode(body: BaseplanCodeWrite & { Code: string }): Promise<BaseplanCode> {
  return apiClient.post<BaseplanCode>('/api/locations/codes', body);
}

/** The whole record: moving a code to another area sends it with the new AreaId. */
export function updateBaseplanCode(code: string, body: BaseplanCodeWrite): Promise<BaseplanCode> {
  return apiClient.patch<BaseplanCode>(`/api/locations/codes/${encodeURIComponent(code)}`, body);
}

/** The editable part of a code, for a PATCH. */
export function toCodeWrite(c: BaseplanCode): BaseplanCodeWrite {
  return {
    Description: c.Description,
    AreaId: c.AreaId,
    ParentCode: c.ParentCode,
    IsBranch: c.IsBranch,
    SortOrder: c.SortOrder,
    ExcludeFromDailySales: c.ExcludeFromDailySales,
    IsActive: c.IsActive,
    Notes: c.Notes,
  };
}
